var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccessLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 7,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0714 17.9285V19.1428C13.0714 20.147 13.8886 20.9642 14.8928 20.9642H16.7143V21.5714C16.7143 22.2411 17.2589 22.7857 17.9286 22.7857C18.0579 22.7857 18.1811 22.7674 18.305 22.7292L21.9588 21.5113C22.4554 21.3388 22.7857 20.8756 22.7857 20.3571V9.42852C22.7857 8.75884 22.2411 8.21423 21.5714 8.21423C21.5417 8.21423 21.5137 8.22516 21.4846 8.22759C21.4621 8.22455 21.4427 8.21423 21.4196 8.21423H14.8928C13.8886 8.21423 13.0714 9.03145 13.0714 10.0357V10.6428C13.0714 10.9779 13.3428 11.2499 13.6786 11.2499C14.0143 11.2499 14.2857 10.9779 14.2857 10.6428V10.0357C14.2857 9.70113 14.5577 9.42852 14.8928 9.42852H17.7209L17.5412 9.48863C17.0446 9.66105 16.7143 10.1243 16.7143 10.6428V19.7499H14.8928C14.5577 19.7499 14.2857 19.4773 14.2857 19.1428V17.9285C14.2857 17.5934 14.0143 17.3214 13.6786 17.3214C13.3428 17.3214 13.0714 17.5934 13.0714 17.9285Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7149 13.8565L12.2863 11.4279C12.1127 11.2542 11.8516 11.202 11.6246 11.2961C11.3981 11.3902 11.2499 11.6118 11.2499 11.8571V13.6786H8.82138C8.48623 13.6786 8.21423 13.9506 8.21423 14.2857C8.21423 14.6208 8.48623 14.8928 8.82138 14.8928H11.2499V16.7143C11.2499 16.9596 11.3981 17.1812 11.6246 17.2753C11.8516 17.3694 12.1127 17.3172 12.2863 17.1435L14.7149 14.715C14.9523 14.4776 14.9523 14.0938 14.7149 13.8565Z",
    fill: "#0085FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccessLine);
export default __webpack_public_path__ + "static/media/icon-access-line.b80f950140533978c53cadf296e3cfb2.svg";
export { ForwardRef as ReactComponent };